export default "__VITE_ASSET__u3Nd2I5l__"